

(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var select = document.getElementById('news-cat');
    if (!select) return;

    select.addEventListener('change', function () {
      var url = select.value;
      if (!url || url === window.location.href.split('#')[0]) return;

      var navigated = false;
      var redirect = function () {
        if (navigated) return;
        navigated = true;
        window.location.href = url;
      };

      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'news_category_selected',
          selected_value: url,
          eventCallback: redirect,
          eventTimeout: 1500
        });

        setTimeout(redirect, 1600);
      } catch (e) {
        redirect();
      }
    });
  });
})();

